export default __webpack_public_path__ + "static/media/mar2024-3.2f8ae8e3.jpg";